"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _MaskedInput = _interopRequireDefault(require("../masked-input/MaskedInput"));

var _Button = _interopRequireDefault(require("../button/Button"));

var _SSNInput = _interopRequireDefault(require("./SSNInput.styles"));

var _excluded = ["className", "defaultMasked", "defaultValue", "disabled", "inputProps", "onChange", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var maskOptions = {
  mask: '000-00-0000'
};

function SSNInput(props) {
  var className = props.className,
      defaultMasked = props.defaultMasked,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      _props$inputProps = props.inputProps,
      inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
      onChange = props.onChange,
      value = props.value,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _SSNInput.default)();

  var _useState = (0, _react.useState)(!!(defaultValue || value)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isButtonVisible = _useState2[0],
      setButtonVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultMasked),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isTextMasked = _useState4[0],
      setTextMasked = _useState4[1];

  var handleChange = function handleChange(e) {
    setButtonVisible(!!e.target.value);

    if (onChange) {
      onChange(e);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_MaskedInput.default, Object.assign({}, otherProps, {
    className: (0, _classnames.default)(classes.root, className),
    defaultValue: defaultValue,
    disabled: disabled,
    endAdornment: /*#__PURE__*/_react.default.createElement(_Button.default, {
      "aria-hidden": !isButtonVisible,
      className: (0, _classnames.default)(classes.button, (0, _defineProperty2.default)({}, classes.buttonVisible, isButtonVisible)),
      disabled: disabled,
      onClick: function onClick() {
        return setTextMasked(!isTextMasked);
      },
      tabIndex: 0,
      type: "button",
      variant: "tertiary"
    }, isTextMasked ? 'SHOW' : 'HIDE'),
    inputMode: "tel",
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      className: (0, _classnames.default)(inputProps.className, (0, _defineProperty2.default)({}, classes.textMasked, !!isTextMasked))
    }),
    maskOptions: maskOptions,
    onChange: handleChange,
    value: value
  }));
}

SSNInput.defaultProps = {
  defaultMasked: true
};
SSNInput.propTypes = {
  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * Set it to `true` to show a `●` character while typing and `false` if you want to
   * show the numbers. This only works when the component is mounted.
   */
  defaultMasked: _propTypes.bool,

  /**
   * @ignore
   */
  defaultValue: _propTypes.string,

  /**
   * @ignore
   */
  disabled: _propTypes.bool,

  /**
   * @ignore
   */
  inputProps: _propTypes.object,

  /**
   * @ignore
   */
  onChange: _propTypes.func,

  /**
   * @ignore
   */
  value: _propTypes.string
};
var _default = SSNInput;
exports.default = _default;
